import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {SignInComponent} from './sign-in/sign-in.component';
import {auth_routing} from './auth.routing';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {ForgotPasswordSubmitComponent} from './forgot-password/forgot-password-submit.component';
import { ResetPasswordComponent } from './forgot-password/reset-password.component';
import {ChangePasswordSubmitComponent} from '../shared/change-password/change-password-submit.component';
import {SharedModule} from '../shared/shared.module';
import {AuthGuard} from './auth.guard';

@NgModule({
  declarations: [
    SignInComponent,
    ForgotPasswordComponent,
    ForgotPasswordSubmitComponent,
    ResetPasswordComponent,
    // ChangePasswordComponent,
    ChangePasswordSubmitComponent

  ],
  imports: [
    CommonModule,
    auth_routing,
    FormsModule,
    // SharedModule
    SharedModule.forRoot()
  ],
  providers: [
    AuthGuard
  ],
  exports: [
    SignInComponent,
    ForgotPasswordComponent,
    ForgotPasswordSubmitComponent,
    ResetPasswordComponent,
    // ChangePasswordComponent,
    ChangePasswordSubmitComponent

  ]
})
export class AuthModule {}
